import { render, staticRenderFns } from "./ProjectPlatformWhatsApp.vue?vue&type=template&id=074348ee"
import script from "./ProjectPlatformWhatsApp.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformWhatsApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports